import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default ({size, color}) => {
    const antIcon = <LoadingOutlined style={{ fontSize: size || 30, color: color || "#FFA400" }} spin />;
    return(
        <Spin indicator={antIcon} />
    )
}